import type { SchoolSizeCostEfficiencyStatus } from './schoolSizeCost.types';

/** ±SCALE_VARIANCE_THRESHOLD_PCT vs size-band expected cost → efficient. */
export const SCALE_VARIANCE_THRESHOLD_PCT = 15;

export function efficiencyStatusLabel(status: SchoolSizeCostEfficiencyStatus): string {
  if (status === 'high_cost_for_size') return 'High cost for size';
  if (status === 'low_cost_for_size') return 'Low cost for size';
  return 'Efficient';
}
